module.exports = __webpack_public_path__ + "img/scouts.bc5ce76e.png";